<template>
  <section class="breadcrumb__container">
    <nav class="breadcrumb">
      <ul>
        <li v-for="(crumb, index) in breadcrumbsWithHome" :key="index">
          <template v-if="index === breadcrumbsWithHome.length - 1">
            <span>{{ crumb.label }}</span>
          </template>
          <template v-else>
            <router-link :to="crumb.to">{{ crumb.label }}</router-link>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.99 9.37L12.05 5.44L12.94 4.55L17.94 9.55L18.38 9.99L17.94 10.44L12.94 15.44L12.05 14.55L15.99 10.62L2.5 10.62L2.5 9.37L15.99 9.37Z"
                fill="#050505"
              />
            </svg>
          </template>
        </li>
      </ul>
    </nav>
  </section>
</template>

<script>
export default {
  computed: {
    breadcrumbs() {
      const route = this.$route;
      return route.matched.map((routeItem) => {
        if (routeItem.meta.breadcrumbDynamic && route.params.slug) {
          return {
            label: route.params.slug,
            to: route.path,
          };
        }
        return {
          label: routeItem.meta.breadcrumb || routeItem.name,
          to: this.getRoutePath(route, routeItem),
        };
      });
    },
    breadcrumbsWithHome() {
      return [{ label: 'Home', to: '/' }, ...this.breadcrumbs];
    },
  },
  methods: {
    getRoutePath(route, routeItem) {
      const matchedSegments = route.matched.slice(
        0,
        route.matched.indexOf(routeItem) + 1
      );
      return matchedSegments.map((segment) => segment.path).join('/');
    },
  },
};

</script>
<style scoped>
.breadcrumb__container{
    padding-top: 40px;
    padding-bottom: 24px;
}
ul{
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: nowrap;
}
ul li{
    display: flex;
    align-items: center;
    max-width: 100%;
}
ul li:last-child {
  flex: 1; /* Растягивает последний элемент */
  min-width: 0; /* Разрешает сжатие */
}
ul li a{
    /* Header/H4: 16px Medium */
    color: rgb(85, 98, 114);
    font-size: 16px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;

}
ul li span{
  color: rgb(5, 5, 5);
  font-size: 16px;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: 0%;
  text-transform: capitalize;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  max-width: 100%;
}
ul li svg{
    margin-left: 16px;
}

</style>